"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiBox = void 0;
const clsx_1 = __importDefault(require("clsx"));
const react_1 = __importDefault(require("react"));
function UiBox(_a) {
    var { element, position, backgroundColor, color, padding, paddingTop, paddingRight, paddingBottom, paddingLeft, paddingHorizontal, paddingVertical, boxShadow, borderRadius, borderRadiusTop, borderRadiusBottom, border, borderTop, borderRight, borderBottom, borderLeft, fullWidth, fullHeight, overflowAuto } = _a, rest = __rest(_a, ["element", "position", "backgroundColor", "color", "padding", "paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "paddingHorizontal", "paddingVertical", "boxShadow", "borderRadius", "borderRadiusTop", "borderRadiusBottom", "border", "borderTop", "borderRight", "borderBottom", "borderLeft", "fullWidth", "fullHeight", "overflowAuto"]);
    const Element = element || 'div';
    return (react_1.default.createElement(Element, Object.assign({}, rest, { className: clsx_1.default(rest.className, 'UiBox', position && `position-${position}`, backgroundColor && `backgroundColor-${backgroundColor}`, color && `color-${color}`, padding && `padding-${padding}`, paddingTop && `paddingTop-${paddingTop}`, paddingRight && `paddingRight-${paddingRight}`, paddingBottom && `paddingBottom-${paddingBottom}`, paddingLeft && `paddingLeft-${paddingLeft}`, paddingHorizontal && `paddingHorizontal-${paddingHorizontal}`, paddingVertical && `paddingVertical-${paddingVertical}`, {
            boxShadow,
            borderRadius,
            borderRadiusTop,
            borderRadiusBottom,
            border,
            borderTop,
            borderRight,
            borderBottom,
            borderLeft,
            fullWidth,
            fullHeight,
            overflowAuto,
        }) })));
}
exports.UiBox = UiBox;
